module.exports = __webpack_public_path__ + "img/scene_phone.93e1d8e7.png";